import { SimulationResolver } from './simulation.resolver';
import { ParametersResolver } from './parameters.resolver';
import { LicenceResolver } from './licence.resolver';
import { LicencesResolver } from './licences.resolver';
import { InvestResolver } from './invest.resolver';
import { DerogationResolver } from './derogation.resolver';
import { HelpResolver } from './help.resolver';
import { GroupingResolver } from './grouping.resolver';
import { ReportCompareResolver } from './report-compare.resolver';
import { ReportSimuResolver } from './report-simu.resolver';


export const resolverProviders = [
    SimulationResolver,
    ParametersResolver,
    LicenceResolver,
    LicencesResolver,
    InvestResolver,
    DerogationResolver,
    HelpResolver,
    GroupingResolver,
    ReportCompareResolver,
    ReportSimuResolver
];
